import {Base} from "./Base";
import {Warehouse} from "./Warehouse"
import {Role} from "./Role";

export enum UserStatus {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
}

export interface User extends Base {
    id: string
    firstName?: string
    lastName?: string
    address?: string
    city?: any
    nationalIdNumber?: string; // Broj licne karte
    nationalIdIssueLocation?: string; // SUP
    personalCodeNumber?: string; // JMBG
    email?: string
    role?: Role
    warehouse?: Warehouse // za rolu magacioner
    username?: string
    password?: string
    accessToken?: string
    status?: UserStatus
}
